<template>
    <div class="on-this-page">
        <div class="on-this-page-wrapper">
            <h3 class="title">On this page</h3>

            <ul class="list">
                <li
                    v-for="(anchor, key) in anchors"
                    :key="key"
                    class="list-item"
                >
                    <a
                        :href="`#${anchor.slug}`"
                        class="link"
                    >
                        {{ anchor.title }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'

import type {
    BlockAnchorFragment,
    ComponentOnThisPageFragment,
} from '@/graphql/api'

defineProps<{
    data: ComponentOnThisPageFragment
}>()

const anchors = inject('cms.anchors') as BlockAnchorFragment[]
</script>

<style lang="scss" scoped>
.on-this-page {
    width: 100%;

    .on-this-page-wrapper {
        width: 740px;
        max-width: 100%;
        padding: 0 20px;
        margin: 0 auto;
    }

    .title {
        text-align: center;
        font-family: $parcel-font-stack;
        font-size: 1.5rem;
        line-height: 1.2em;
        margin: 80px 0 40px;
    }

    .list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;

        .list-item {
            width: 100%;
            flex-shrink: 0;
            @include border-bottom;

            text-transform: uppercase;

            @include min-width(768) {
                width: calc(50% - 20px);
            }

            .link {
                display: block;
                font-family: $effra-font-stack;
                letter-spacing: 0.05em;
                font-weight: 400;
                font-size: 0.875rem;
                line-height: 20px;
                padding: 20px 10px;

                @include min-width(768) {
                    padding: 20px 0;
                }
            }
        }
    }
}
</style>
